/* Purpose: Pop up to confirm a status update action
 * Props: ClientID (str)
 *        LoanID (str)
 *        currentStatus (str)
 *        updateLoanStatus (func)
 *        onHide (func)
 * Author: R. Markowitz (May 2025)
 * Dev Notes: 
*/

import {Button, Spinner} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import React, {useState} from 'react';

const ConfirmStatusUpdate = (props) => {
    const ClientID = props.ClientID;
    const LoanID = props.LoanID;
    const currentStatus = props.currentStatus;
    const updateLoanStatus = props.updateLoanStatus;
    const setLoanBasicInfo = props.setLoanBasicInfo;
    const [updating, setUpdating] = useState(false);
    const updateStatus = currentStatus == "Intake"?("Processing"):(currentStatus == "Processing"?("Underwriting"):("Approved"))

    const handleUpdate = async() => {
        setUpdating(true);
        await updateLoanStatus(ClientID, LoanID, currentStatus, setLoanBasicInfo);
        props.onHide();
    }
    

    return(
        <Modal
        show = {true}
        onHide = {props.onHide}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
        <Modal.Header closeButton>
            <Modal.Title id="confirm-delete">
                Update the status of loan "{LoanID}"?
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
                <p>The current status of "{LoanID}" is "{currentStatus}". Updating this loan will set the status to "{updateStatus}".</p> 
                <p>Updating the status of this loan can not be undone.</p>
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={props.onHide}>Cancel</Button>
            <Button onClick={handleUpdate}>
                {updating? (
                    <>
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Updating Status...
                    </>
                    
                ):<>
                    Update Status
                </>} 
                   
            </Button>
        </Modal.Footer>
        </Modal>
    );
};

export default ConfirmStatusUpdate; 